// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__IL2Uu","copyright":"footer_copyright__3K2cS"};